export const shouldReloadForStaleBuild = (isOnline: boolean): boolean => isOnline;
